import styled from "styled-components";

export const Container = styled.div`
@media screen and (min-width: 1000px){
    section{
        margin: 50px 0 0 10%;
    }

}
`;